import './MuteToggleButton.css';
import { ReactComponent as MutedIcon } from "../../media/volume-off.svg";
import { ReactComponent as UnmutedIcon } from "../../media/volume-on.svg";


const MuteToggleButton = (props) => {
    return (
        <button className="btn-toggle-mute" onClick={() => props.toggleMute()}>
        {props.isMuted ? <MutedIcon/>:<UnmutedIcon/>}
        </button>
     );
}
 
export default MuteToggleButton;